(function () {
  'use strict';
  if (window.KnickerBundleSavings) return;
  var products = Object.create(null);
  var generation = 0;
  var lastCount = null;
  function eligible(item, product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    if (tags.some(function (tag) { return String(tag).trim().toLowerCase() === 'sale'; })) return false;
    if (product.gift_card || /gift[\s_-]*(box|card)/i.test([product.handle, product.type, product.title, item.handle].join(' '))) return false;
    var hasSize = (product.options || []).some(function (option) { return String(option.name || option).toLowerCase() === 'size'; });
    if (!hasSize) return false;
    var variant = product.variants.find(function (value) { return String(value.id) === String(item.variant_id || item.id); });
    if (!variant) return null;
    return !(Number(variant.compare_at_price) > Number(variant.price));
  }
  function productFor(item) {
    if (item.product && eligible(item, item.product) !== null) return Promise.resolve(item.product);
    var handle = item.handle;
    if (!handle) return Promise.resolve(null);
    if (!products[handle]) {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      products[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .catch(function () { delete products[handle]; return null; });
    }
    return products[handle];
  }
  function message(count) {
    if (count === null) return 'Bundle savings: 10% for 5, 13% for 7, and 15% for 10 full-price knickers.';
    var discount = count >= 10 ? 15 : count >= 7 ? 13 : count >= 5 ? 10 : 0;
    var next = count < 5 ? 5 : count < 7 ? 7 : count < 10 ? 10 : 0;
    var nextDiscount = count < 5 ? 10 : count < 7 ? 13 : 15;
    var text = discount ? 'Your ' + count + ' full-price knickers qualify for ' + discount + '% off.' : '';
    if (next) text += (text ? ' ' : '') + 'Add ' + (next - count) + ' more full-price ' + (next - count === 1 ? 'knicker' : 'knickers') + ' to qualify for ' + nextDiscount + '% off.';
    return text;
  }
  function paint(count) {
    lastCount = count;
    document.querySelectorAll('[data-bundle-progress]').forEach(function (element) { element.textContent = message(count); });
  }
  window.KnickerBundleSavings = {
    eligible: eligible,
    message: message,
    update: function (items) {
      var current = ++generation;
      items = Array.isArray(items) ? items : [];
      var known = items.map(function (item) { return eligible(item, item.product); });
      if (known.every(function (value) { return value !== null; })) {
        paint(items.reduce(function (count, item, index) { return count + (known[index] ? Number(item.quantity) || 0 : 0); }, 0));
        return Promise.resolve(lastCount);
      }
      paint(null);
      return Promise.all(items.map(function (item) { return productFor(item); })).then(function (values) {
        var count = 0;
        var complete = true;
        items.forEach(function (item, index) {
          var qualifies = eligible(item, values[index]);
          if (qualifies === null) complete = false;
          if (qualifies) count += Number(item.quantity) || 0;
        });
        if (current === generation) paint(complete ? count : null);
        return complete ? count : null;
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(lastCount); });
})();
